"use client";

import { BSRClose } from "./bsr/BSRClose";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { Close as LegacyClose } from "./legacy/Close";

export const Close = createBSRExperimentIcon(LegacyClose, BSRClose);
